import { Box, Cart, Tv } from "iconoir-react";
import React from "react";
import { useNavigate } from "react-router-dom";
import Dashboard from "../../Dasboard/Dashboard";
import emtvIcono from "../../../assets/EmtvPlus/EmtvIcono.png";
import Swal from "sweetalert2";
import { domain } from "../../../Urls/Services/Api_urls";
import { getVincularContratoHtml } from "../shared/vincularContratoHtml";
import "../AdminServices/AdminSol.css";

const formatApiError = (msg) => {
  if (!msg) return "Error al registrar el usuario";
  if (typeof msg === "string") return msg;
  if (typeof msg === "object") {
    return Object.entries(msg)
      .flatMap(([, errors]) => (Array.isArray(errors) ? errors : [errors]))
      .join(" • ");
  }
  return "Error al registrar el usuario";
};

export const Selectypebuy = () => {
  const navigate = useNavigate();

  const createPackage = async (contractData) => {
    const token = window.sessionStorage.getItem("token");
    const response = await fetch(`${domain}/post2venta/post/create/package/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
      body: JSON.stringify({
        contracted_service: contractData.contract_open.contracted_service,
        cc_user_contrated: contractData.contract_open.cc_user_contract,
        username: window.sessionStorage.getItem("emailRes"),
        options: contractData.options,
        log_history: contractData.log_history,
      }),
    });

    const result = await response.json();

    if (!response.ok || result.type !== "success") {
      throw new Error(result.msg || "Error al vincular el contrato");
    }
  };

  const goToEmtvPlans = async (contractData) => {
    const cuentaOrigen = contractData.user_actual?.username;
    const cuentaDestino = contractData.user_update?.username || "Nuevo usuario";
    const solicitante = contractData.user_request?.username || "N/A";
    const contrato = contractData.contract_open.contracted_service;

    const origenTexto = cuentaOrigen
      ? `El contrato <strong>${contrato}</strong> estaba vinculado a la cuenta <strong>${cuentaOrigen}</strong> y será reasignado a la cuenta <strong>${cuentaDestino}</strong>, por solicitud del usuario <strong>${solicitante}</strong>.`
      : `El contrato <strong>${contrato}</strong> no está vinculado a ninguna cuenta en el portal y se va a vincular a la cuenta <strong>${cuentaDestino}</strong>, por solicitud del usuario <strong>${solicitante}</strong>.`;

    const infoHtml = `
      <p style="text-align:center; font-size:16px; margin-top:5px;">${origenTexto}</p>
      <p style="text-align:center; font-size:16px; margin-top:8px;">¿Desea continuar con el proceso de empaquetamiento?</p>
    `;

    const { value: confirmed } = await Swal.fire({
      icon: "info",
      title: "Información del proceso",
      html: infoHtml,
      showLoaderOnConfirm: true,
      showCancelButton: true,
      confirmButtonText: "Confirmar",
      cancelButtonText: "Cancelar",
      reverseButtons: true,
      allowOutsideClick: () => !Swal.isLoading(),
      preConfirm: async () => {
        try {
          await createPackage(contractData);
          return true;
        } catch (err) {
          Swal.showValidationMessage(err.message || "Error de conexión. Por favor intente de nuevo.");
          return false;
        }
      },
    });

    if (!confirmed) return;

    window.sessionStorage.setItem("id_sigt", contractData.contract_open.idcontract);
    window.sessionStorage.setItem("estratoInc", contractData.contract_open.estrato);
    window.sessionStorage.setItem("sus", contrato);
    window.sessionStorage.setItem("idact", contrato);
    window.sessionStorage.setItem("emtvUnifiedSale", "true");

    navigate(`/AddEmtvPlus/${contrato}`);
  };

  const handleEmpaquetarEMTV = async (e) => {
    e.preventDefault();

    const { value: contractData } = await Swal.fire({
      title: "Vincula el contrato a la cuenta de Portal Servicios",
      html: getVincularContratoHtml({ showWarning: true }),
      confirmButtonColor: "#4a1272",
      confirmButtonText: "Enviar",
      showCloseButton: true,
      focusConfirm: false,
      allowOutsideClick: () => !Swal.isLoading(),
      preConfirm: async () => {
        const contrato = document.getElementById("subs").value.trim();
        const cedula = document.getElementById("docu").value.trim();
        const token = window.sessionStorage.getItem("token");

        if (!contrato || !cedula) {
          Swal.showValidationMessage("Por favor digite todos los campos");
          return false;
        }

        const username = window.sessionStorage.getItem("emailRes");

        
        try {
          const response = await fetch(`${domain}/post2venta/get/customer-contract/`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "Authorization": `Bearer ${token}`,
            },
            body: JSON.stringify({
              contracted_service: contrato,
              cc_user_contrated: cedula,
              username,
            }),
          });

          const result = await response.json();

          if (!response.ok || result.type !== "success") {
            Swal.showValidationMessage(result.msg || "Error al consultar el contrato");
            return false;
          }

          window.sessionStorage.setItem("emtvContractData", JSON.stringify(result.data));

          return result.data;
        } catch {
          Swal.showValidationMessage("Error de conexión. Por favor intente de nuevo.");
          return false;
        }
      },
    });

    if (!contractData) return;

    const { options } = contractData;

    if (options === "venta3" || options === "venta4") {
      const emailRes = window.sessionStorage.getItem("emailRes");

      const { value: registerResult } = await Swal.fire({
        title: "Registro de usuario",
        customClass: { popup: "swal-registro-modal" },
        html:
          "<h6 class='' style='margin-top: 5px; font-weight: bold;'>Correo electrónico</h6>" +
          `<input id="reg-username" class="swal2-input" value="${emailRes}" readonly` +
          " style='width: 100%; color: black; background-color: #f5f5f5; cursor: not-allowed;'>" +
          "<h6 class='' style='margin-top: 10px; font-weight: bold;'>Confirmar correo electrónico</h6>" +
          '<input id="reg-email-confirm" class="swal2-input" placeholder="Confirme el correo electrónico *" style="width: 100%; color: black;">' +
          "<h6 class='' style='margin-top: 10px; font-weight: bold;'>Identificación</h6>" +
          '<input id="reg-dni" class="swal2-input" placeholder="Identificación *" style="width: 100%; color: black;">' +
          "<h6 class='' style='margin-top: 10px; font-weight: bold;'>Nombre</h6>" +
          '<input id="reg-name" class="swal2-input" placeholder="Nombre *" style="width: 100%; color: black;">' +
          "<h6 class='' style='margin-top: 10px; font-weight: bold;'>Apellido</h6>" +
          '<input id="reg-lastname" class="swal2-input" placeholder="Apellido *" style="width: 100%; color: black;">' +
          "<h6 class='' style='margin-top: 10px; font-weight: bold;'>Celular</h6>" +
          '<input id="reg-phone" class="swal2-input" placeholder="Celular *" style="width: 100%; color: black;">' +
          '<div style="display:flex; align-items:center; justify-content:center; gap:8px; margin-top:14px;">' +
            '<input id="reg-terms" type="checkbox" style="width:18px; height:18px; cursor:pointer; flex-shrink:0;">' +
            '<a href="https://www.emcali.com.co/proteccion-de-datos-personales" target="_blank" rel="noopener noreferrer" style="color:#4a1272; font-weight:bold; text-decoration:underline; font-size:15px;">Términos y condiciones</a>' +
          '</div>',
        confirmButtonColor: "#4a1272",
        confirmButtonText: "Registrar",
        showCloseButton: true,
        focusConfirm: false,
        showLoaderOnConfirm: true,
        allowOutsideClick: () => !Swal.isLoading(),
        preConfirm: async () => {
          const emailConfirm = document.getElementById("reg-email-confirm").value.trim();
          const name = document.getElementById("reg-name").value.trim();
          const last_name = document.getElementById("reg-lastname").value.trim();
          const dni = document.getElementById("reg-dni").value.trim();
          const phone = document.getElementById("reg-phone").value.trim();
          const termsAccepted = document.getElementById("reg-terms").checked;

          if (!emailConfirm || !dni || !name || !last_name || !phone) {
            Swal.showValidationMessage("Por favor complete todos los campos");
            return false;
          }

          if (emailConfirm !== emailRes) {
            Swal.showValidationMessage("Los correos electrónicos no coinciden");
            return false;
          }

          if (!termsAccepted) {
            Swal.showValidationMessage("Debes aceptar los términos y condiciones para continuar");
            return false;
          }

          const token = window.sessionStorage.getItem("token");
          const username = window.sessionStorage.getItem("emailRes");

          try {
            const regResponse = await fetch(`${domain}/user/register/`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
              },
              body: JSON.stringify({
                action: "UnifiedSaleUser",
                name,
                last_name,
                dni,
                phone,
                password: "Emcali2026*",
                username,
              }),
            });

            const regResult = await regResponse.json();

            if (!regResponse.ok || regResult.type !== "success") {
              Swal.showValidationMessage(formatApiError(regResult.msg));
              return false;
            }

            return regResult;
          } catch {
            Swal.showValidationMessage("Error de conexión. Por favor intente de nuevo.");
            return false;
          }
        },
      });

      if (!registerResult) return;

      await goToEmtvPlans(contractData);

    } else if (options === "venta1" || options === "venta2") {
      await goToEmtvPlans(contractData);
    }
  };

  return (
    <>
      <Dashboard
        MInicio={""}
        Msolicitudes={""}
        Mservicios={""}
        Mcompra={""}
        Mcunyompra={"active"}
        Mempaquetar={""}
        Mcpotenciales={""}
        Madminportal={""}
        Mcampaña={""}
        Mtv={""}
      >
      <section className="home-section" style={{ margin: 1, padding: "1rem" }}>

        <h3 className="py-10">
          <b>Tipo de usuario <b className="text-colorprimarygreen">{window.sessionStorage.getItem('Register') === 'No' ? 'Nuevo' : 'Registrado'}</b></b>
        </h3>
        <h4 className="mb-5">
          <b>Consultar tipo de venta</b>
        </h4>

        <div className="flex flex-col items-center gap-4 mt-4">
          <div className="flex justify-center items-center gap-4 max-sm:flex-col">
            <a
              className="bg-colorprimary shadow-md border border-gray-100 overflow-hidden hover:-translate-y-2 hover:shadow-2xl transition-all duration-300 text-white w-52 flex justify-center items-center rounded-xl no-underline p-1 hover:brightness-110"
              href="/createsol"
            >
              <Cart style={{margin: "10px"}}/>
              Producto nuevo
            </a>
            <a
              className="bg-colorprimary shadow-md border border-gray-100 overflow-hidden hover:-translate-y-2 hover:shadow-2xl transition-all duration-300 text-white w-52 flex justify-center items-center rounded-xl no-underline p-1 hover:brightness-110 transition-all duration-200 cursor-pointer"
              onClick={handleEmpaquetarEMTV}
            >
              <img src={emtvIcono} alt="EMTV+" className="w-7 h-7 m-2 object-contain" />
              Empaquetar EMTV+
            </a>
            <a
              className="bg-colorprimary shadow-md border border-gray-100 overflow-hidden hover:-translate-y-2 hover:shadow-2xl transition-all duration-300 text-white w-52 flex justify-center items-center rounded-xl no-underline p-1 hover:brightness-110 transition-all duration-200"
              href="/EmpaquetarinU"
            >
              <Box style={{margin: "10px"}}/>
                Empaquetar
            </a>
          </div>
        </div>
      </section>
      </Dashboard>
    </>
  );
};
